import React from 'react';
import Grid from '@material-ui/core/Grid';
import Skeleton from '@material-ui/lab/Skeleton';

const LoadingIdentityDocument = () => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}><Skeleton variant="rect" height={40} /></Grid>
            <Grid item xs={12}><Skeleton variant="rect" height={40} /></Grid>
            <Grid item xs={12}><Skeleton variant="rect" height={40} /></Grid>
            <Grid item xs={12}><Skeleton variant="rect" height={40} /></Grid>
            <Grid item xs={12}><Skeleton variant="rect" height={40} /></Grid>
            <Grid item xs={12}><Skeleton variant="rect" height={40} /></Grid>
            <Grid item xs={12}><Skeleton variant="rect" height={40} /></Grid>
            <Grid item xs={12}><Skeleton variant="rect" height={40} /></Grid>
            <Grid item xs={12}><Skeleton variant="rect" height={40} /></Grid>
            <Grid item xs={12}><Skeleton variant="rect" height={40} /></Grid>
            <Grid item xs={12}><Skeleton variant="rect" height={40} /></Grid>
            <Grid item xs={12}><Skeleton variant="rect" height={40} /></Grid>
            <Grid item xs={12}><Skeleton variant="rect" height={40} /></Grid>
            <Grid item xs={12}><Skeleton variant="rect" width={78} height={40} /></Grid>
        </Grid>
    );
};
export default LoadingIdentityDocument;